<template>
  <el-card
    shadow="never"
    class="ads1-list-container"
  >
    <div class="item line-separator">
      <el-row>
        <el-col
          :sm="5"
          class="image"
        >
          <vue-load-image v-if="paramItem && paramItem.file">
            <img
              slot="image"
              :src="paramItem.file.url_view | resizeImage(707, 486)"
              :data-src="paramItem.file.url_view | resizeImage(707, 486)"
              class="img-responsive pointer"
              @click="viewAd"
            >
            <div
              slot="preloader"
              v-loading="true"
              class="img-loading"
            >
              {{ $t('Loading ....') }}
            </div>
            <div slot="error">
              {{ $t('Network error') }}
            </div>
          </vue-load-image>
          <img
            v-else
            class="img-responsive pointer"
            src="../../assets/no-image.png"
            @click="viewAd"
          >
        </el-col>
        <div class="about-min-height">
          <el-col
            :sm="9"
            class="content m-l-sm-15"
          >
            <div
              class="pointer"
              @click="viewAd"
            >
              <div class="title">
                {{ paramItem.name | truncate(50) }}
              </div>
              <div
                v-if="paramItem.category && paramItem.category.parent"
                class="ad1-category"
              >
                {{ `${paramItem.category.parent.name} > ${paramItem.category.name}` }}
              </div>
            </div>
            <div
              v-if="!isMyAds && !isMobile && paramItem.contact_info"
              class="location"
            >
              <i class="icon-place" />{{ paramItem.contact_info.location }}
            </div>
            <div
              v-if="!isMyAds && !isMobile && paramItem.publish_date"
              class="date"
            >
              {{ paramItem.publish_date | formatDate('D MMMM Y') }}
            </div>
          </el-col>
          <el-col
            :sm="6"
            :offset="1"
            class="price"
          >
            <div class="price-value">
              {{ paramItem.price | formatMoney(0) }} {{ paramItem.currency ? paramItem.currency.code : '' }}
            </div>
            <div
              v-if="!isMyAds && !isMobile"
              class="option"
            >
              {{ paramItem.option }}
            </div>
            <favorite
              v-if="paramItem.active && !isMyAds"
              v-model="isFavorite"
              :res="'ads/favourite'"
              :entity-id="paramItem.id"
              :entity-name="'ad_id'"
              @reloadList="$emit('reloadList')"
            />
          </el-col>
        </div>
        <my-ads-list
          v-if="isMyAds"
          :is-inactive="!paramItem.active"
          :favorites-count="paramItem.favorites_count"
          :messages-count="paramItem.messages_count"
          :viewers-count="paramItem.viewers_count"
          @activeChange="updateActive"
          @onDelete="onDelete"
          @onFeature="$router.push({ name: 'FeatureAd', params: { id: paramItem.id }})"
          @onEdit="$router.push({ name: 'EditAd', params: { id: paramItem.id }})"
        />
      </el-row>
    </div>
  </el-card>
</template>
<script>
  import { mapState } from 'vuex';
  import mutations from '@/store/ads/ads.mutationlist';
  import Favorite from '@/components/Core/Favorite';
  import MyAdsList from '../../components/Ads/MyAds';
  import ResourcePage from '../../components/Core/ResourcePage';

  export default {
    components: {
      MyAdsList,
      Favorite,
    },
    extends: ResourcePage,
    props: {
      isMyAds: {
        type: Boolean,
        default: false,
      },
      state: {
        type: Boolean,
        default: false,
      },
      paramItem: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        resource: 'ads',
        favUser: null,
      };
    },
    computed: {
      isFavorite: {
        get() {
          return this.favUser;
        },
        set(val) {
          this.favUser = val;
          if (this.state) {
            this.$store.commit(
              mutations.UPDATE_AD,
              {
                ...this.paramItem,
                favoring_logged_in_user: this.favUser,
              });
          }
        },
      },
      ...mapState({
        isMobile: state => state.isMobile,
        url: state => state.config ? state.config.apiUrl.replace('/api', '') : '',
      }),
    },
    watch: {
      paramItem(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.favUser = newVal ? newVal.favoring_logged_in_user : null;
        }
      },
      isFavorite(newVal) {
        if (newVal) {
          // this.$emit('reloadList');
        }
      },
    },
    mounted() {
      this.favUser = this.paramItem ? this.paramItem.favoring_logged_in_user : null;
    },
    methods: {
      viewAd() {
        this.$router.push({ name: 'Ad', params: { id: this.paramItem.id } });
      },
      updateActive(active) {
        this.provider.update(this.paramItem.id, { active })
          .then(() => {
            this.$emit('changed', { ...this.paramItem, active });
          });
      },
      onDelete() {
        this.$confirm(this.$t('account-settings.my-ads.delete.text'), this.$t('account-settings.my-ads.warning'), {
          confirmButtonText: this.$t('account-settings.my-ads.delete.ok'),
          cancelButtonText: this.$t('account-settings.my-ads.delete.cancel'),
          type: 'warning',
        }).then(() => {
          this.provider.remove(this.paramItem.id)
            .then(() => {
              this.$emit('changed', { ...this.paramItem });
              this.$message({
                type: 'success',
                message: this.$t('account-settings.my-ads.delete.success'),
              });
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('account-settings.my-ads.delete.canceled'),
          });
        });
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Ads/AdsRow.vue